import { FC, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';
import Home from '../Home';
import SearchDialog from './SearchDialog';
import { parseCriteria } from './criteria';
import { originPathFrom, returnPathFrom } from './paths';

// "/search": the Home with the "Chercher un document" modal open on top
// (XD screen 6), like "/archive" with the wizard. The initial criteria
// come from the query string; closing the modal returns to the route it was
// opened from (`location.state.from`: the Home, or Résultats after "Modifier ma
// recherche"), and to "Mes documents" if reached by direct URL.
//
// The background Home is that of the origin route, so that closing does not change the
// listing that was underneath. Its tiles are hidden while the modal is open:
// the XD modal artboards show the header over an empty page (DESIGN.md,
// screens 3-6 and 9).

export { SEARCH_PATH, SEARCH_RESULTS_PATH } from './paths';

const Search: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    document.title = 'ArchivOs - Chercher un document';
  }, []);

  const returnPath = returnPathFrom(location.state);
  // Where Résultats' "‹ Retour" leads (see paths.ts): the route the flow was
  // entered from when that is outside the flow, otherwise whatever origin
  // Résultats threaded back through "Modifier ma recherche".
  const origin =
    originPathFrom(location.state) ??
    (returnPath.startsWith('/search') ? '/my-documents' : returnPath);
  const scope = origin.startsWith('/all-documents') ? 'all' : 'me';

  // The form is local state of the modal; the query string only seeds it.
  // The key makes a different query (another "Modifier ma recherche", the
  // tile pressed from here) mount a new form instead of keeping the
  // previous one.
  const query = searchParams.toString();

  return (
    <Home scope={scope} hideTiles>
      <SearchDialog
        key={query}
        open
        initial={parseCriteria(searchParams)}
        origin={origin}
        onClose={() => navigate(returnPath)}
      />
    </Home>
  );
};

export default Search;
